import React from "react"
import PropTypes from "prop-types"
import { CHAT_SOURCES, getChatSource } from "helpers/chat_source"
import InspectionAppLogo from "assets/images/rd-small-logo.webp"

function ChatSourceIcon({ source, chat, className = "" }) {
  const resolvedSource = source || getChatSource(chat)

  if (!resolvedSource) return null

  const isEndUser = resolvedSource === CHAT_SOURCES.endUser
  const label = isEndUser ? "Inspection app" : "WhatsApp"

  return (
    <span
      className={`chat-source-icon ${
        isEndUser ? "chat-source-icon-end-user" : "chat-source-icon-whatsapp"
      } ${className}`}
      title={label}
      aria-label={label}
    >
      {isEndUser ? (
        <img
          src={InspectionAppLogo}
          alt=""
          aria-hidden="true"
          className="chat-source-logo"
        />
      ) : (
        <i className="bx bxl-whatsapp"></i>
      )}
    </span>
  )
}

ChatSourceIcon.propTypes = {
  source: PropTypes.string,
  chat: PropTypes.object,
  className: PropTypes.string,
}

export default ChatSourceIcon
